// src/components/Careers.js
import React, { useRef, useState } from "react";
import { Formik, Form, Field } from "formik";
import FAQSection from "./faqSectionCareers";
import emailjs from "emailjs-com";
import { json } from "react-router-dom";
const Careers = () => {
  const positions = [
    { title: "Machine Operator" },
    { title: "Electrician" },
    { title: "Garment Inspector" },
    { title: "Fabric Inspector" },
  ];

  // Create a ref to attach to the form element
  const formRef = useRef(null);

  // Function to scroll to the form
  const scrollToForm = () => {
    formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // State to store the submitted form data
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false); // State to manage loading status
  // Handle form submission
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    // Store the form data in the state
    setFormData(values);
    setLoading(true);
    const templateParams = {
      message: JSON.stringify(values),
    };
    if (loading) {
      return;
    }

    emailjs
      .send(
        "service_p75x8yg",
        "template_e2c1dkj",
        templateParams,
        "bybF36Fy2yFIoVwDm"
      )
      .then(
        (result) => {
          alert("Applied Successfully!!");
          setLoading(false); // Reset loading state
          resetForm(); // Reset the form fields
        },
        (error) => {
          alert("Error occured. Pls contact customer care at +919445202342");
          setLoading(false); // Reset loading state
        }
      );
    setSubmitting(false); // Set submitting to false after form is processed
  };

  return (
    <div className="pt-20">
      <div
        className="  font-poppins  "
        style={{
          height: "55vh",
          width: "100%",
          backgroundImage: "url('/careers_bg_image1.png')",
          backgroundSize: "100% 100%",

          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="h-[100%] w-full -mt-4 flex items-center justify-center flex-col md:flex-row    md:mr-0">
          <div className="text-white font-bold text-3xl md:text-4xl lg:text-5xl inline-block">
            Discover your
          </div>
          <div className="text-white font-bold text-5xl m-4 mt-4 md:mt-4">
            <a href="/" className="">
              <img src="/POTENTIAL.png" alt="Logo" className="h-12 md:h-16" />
            </a>
          </div>
          <div className="text-white font-bold text-3xl md:text-4xl lg:text-5xl inline-block">
            {" "}
            <div className="-mt-16 -ml-10 bg-red-700 text-sm rounded-full rounded-bl-none absolute p-3 hidden md:block ">
              we are hiring
            </div>{" "}
            <div className="-mt-24 ml-48 bg-red-700 text-sm rounded-full rounded-bl-none absolute p-2 block md:hidden whitespace-nowrap ">
              Hiring
            </div>{" "}
            at Madura
          </div>
        </div>
      </div>
      <FAQSection></FAQSection>
      <div className="overflow-x-auto font-bold p-8 md:p-12 text-3xl bg-[#F6F4F2] relative ">
        Open roles
        <div className="pl-0 pr-0 md:pl-12 md:pr-12 ">
          <table className="min-w-full text-lg mt-4 md:mt-10 mb-8">
            <thead>
              <tr className="text-center">
                <th className="py-2 px-4 font-bold border-b border-black">
                  Positions
                </th>
                <th className="py-2 px-4 border-b border-black"></th>
              </tr>
            </thead>
            <tbody>
              {positions.map((position, index) => (
                <tr key={index} className="text-center">
                  <td className="py-4 px-4 font-bold">{position.title}</td>
                  <td className="py-4 px-4">
                    <div
                      className="text-red-600 pl-3 pr-3 underline cursor-pointer"
                      onClick={scrollToForm}
                    >
                      Apply
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-sm flex flex-row absolute bottom-0 left-0 w-full p-2 md:p-4 pl-10 ">
          <div className="font-normal">*Not seeing your role?</div>
          <div className="font-bold  underline ml-1" onClick={scrollToForm}>
            {" "}
            We are always hiring. Apply here.
          </div>
        </div>
      </div>

      <div className="relative ">
        <div className="absolute top-0 right-0">
          <div className="      -mt-8 hidden md:block">
            <img src="/DotsContactUs.svg" alt="" className="h-12" />
          </div>
        </div>
        <div className="max-w-2xl mx-auto p-6    " ref={formRef}>
          <header className="text-center mb-6">
            <h1 className="text-3xl font-bold text-gray-800">Apply here!</h1>
          </header>
          <p className="text-center text-2xl     mb-8">Join us</p>
          <Formik
            initialValues={{ name: "", email: "", phoneNumber: "", resume: "" }}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-gray-700">
                    Name:
                  </label>
                  <Field
                    type="text"
                    id="name"
                    name="name"
                    className="w-full p-3 border border-gray-300 rounded-full"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-gray-700">
                    Email:
                  </label>
                  <Field
                    type="email"
                    id="email"
                    name="email"
                    className="w-full p-3 border border-gray-300 rounded-full"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="phoneNumber" className="block text-gray-700">
                    Phone Number:
                  </label>
                  <Field
                    type="number"
                    id="phoneNumber"
                    name="phoneNumber"
                    className="w-full p-3 border border-gray-300 rounded-full"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="resume" className="block text-gray-700">
                    Resume (URL):
                  </label>
                  <Field
                    type="text"
                    id="resume"
                    name="resume"
                    className="w-full p-3 border border-gray-300 rounded-full"
                    required
                  />
                </div>
                <div className="w-full  flex items-center justify-center">
                  <button
                    disabled={isSubmitting}
                    type="submit"
                    className=" p-3  bg-gray-800 text-white py-3 rounded-full hover:bg-gray-700"
                  >
                    {loading ? "Applying..." : "Apply Now"}{" "}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="absolute bottom-0 left-0 mb-12">
          <div className="hidden md:block      ">
            <img src="/CareersForm.svg" alt="" className="h-52" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers;
